import * as React from "react";
import styled, { css } from "../../../styled/index";
// import { ButtonColors, ButtonSizes } from "../index";
import { Button } from "../index";
const getRoundButtonGroup = css `
  button {
    &:first-child {
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
    }
    &:last-child {
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
`;
const ButtonGroupComponent = styled("div") `
  display: inline-block;
  white-space: pre;
  button {
    border-radius: 0;
    padding: 0;
    width: ${(props) => props.width === "auto" ? props.width : `${props.width}px`}; 
    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  };
  ${(props) => props.round ? getRoundButtonGroup : ""}
`;
const calculateButtonWidth = (name, options) => {
    switch (options.length) {
        case 1:
            return '100%';
        case 2:
            const anyLongName = options.some((o) => o.name.length > 23);
            return anyLongName ? '100%' : '49%';
        case 3:
            return '32%';
        default:
            switch (true) {
                case (name.length < 14):
                    return '32%';
                case (name.length >= 14 && name.length < 23):
                    return '49%';
                default:
                    return '100%';
            }
    }
};
export const ButtonGroup = (props) => (React.createElement(ButtonGroupComponent, { width: props.width, round: props.round, className: props.className, style: props.buttonWidth ? { display: 'flex', flexWrap: 'wrap', gap: '6px', borderRadius: '4px', alignContent: 'center', whiteSpace: 'unset', width: '100%' } : {} }, props.options.map((o, i) => {
    const buttonWidth = calculateButtonWidth(o.name, props.options);
    return (React.createElement(Button, { type: "button", key: i, size: props.size, className: props.buttonClassName || "", color: o.value === props.selected ? "primary" : props.baseColor, onClick: (e) => props.onSelect(o, e), style: props.buttonWidth ? { width: buttonWidth } : {} }, o.name));
})));
//# sourceMappingURL=index.js.map